/** Formatting, in one place, so every screen prints a dollar the same way. */
export const money = (cents: number | string | null | undefined, opts: { compact?: boolean } = {}) => {
  const n = Number(cents ?? 0) / 100
  if (opts.compact && Math.abs(n) >= 10000) return `$${(n / 1000).toFixed(1)}k`
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 })
}
/** Money as people say it in an offer: "$100", and cents only when there are some ("$312.50"). */
export const dollars = (cents: number | string | null | undefined) => {
  const c = Number(cents ?? 0)
  return c % 100 === 0 ? (c / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }) : money(c)
}
export const cuft = (n: number | string | null | undefined, digits = 0) => `${Number(n ?? 0).toLocaleString('en-US', { maximumFractionDigits: digits, minimumFractionDigits: digits })} cu ft`
export const num = (n: number | string | null | undefined, digits = 0) => Number(n ?? 0).toLocaleString('en-US', { maximumFractionDigits: digits, minimumFractionDigits: digits })

export const dateShort = (d: string | Date | null | undefined) => {
  if (!d) return ''
  const x = typeof d === 'string' ? new Date(d.length === 10 ? d + 'T12:00:00' : d) : d
  return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
export const dateLong = (d: string | Date | null | undefined) => {
  if (!d) return ''
  const x = typeof d === 'string' ? new Date(d.length === 10 ? d + 'T12:00:00' : d) : d
  return x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
}
export const timeShort = (d: string | Date | null | undefined) => {
  if (!d) return ''
  const x = typeof d === 'string' ? new Date(d) : d
  return x.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}
export const ago = (d: string | Date | null | undefined) => {
  if (!d) return ''
  const t = (typeof d === 'string' ? new Date(d) : d).getTime()
  const s = Math.round((Date.now() - t) / 1000)
  if (s < 60) return 'just now'
  if (s < 3600) return `${Math.round(s / 60)} min ago`
  if (s < 86400) return `${Math.round(s / 3600)} hr ago`
  const days = Math.round(s / 86400)
  return days === 1 ? 'yesterday' : `${days} days ago`
}
/** Days from today to a date. Negative is past. */
export const daysUntil = (d: string | null | undefined) => {
  if (!d) return null
  const x = new Date(d.length === 10 ? d + 'T12:00:00' : d)
  const today = new Date(); today.setHours(12, 0, 0, 0)
  return Math.round((x.getTime() - today.getTime()) / 86400000)
}
export const relDay = (d: string | null | undefined) => {
  const n = daysUntil(d)
  if (n === null) return ''
  if (n === 0) return 'today'
  if (n === 1) return 'tomorrow'
  if (n === -1) return 'yesterday'
  return n > 0 ? `in ${n} days` : `${-n} days ago`
}
export const title = (s: string | null | undefined) => (s || '').replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
